import { useEffect } from "react";
import { useLocation } from "@tanstack/react-router";
import { trackPageView } from "@/lib/analytics";

// Envia um page_view a cada troca de rota. Espera o <title> ser atualizado
// pelo router (ou 1,5 s, se o título não mudar) para registrar o título certo.
const AnalyticsTracker = () => {
  const { pathname, searchStr } = useLocation();

  useEffect(() => {
    const pageLocation = window.location.href;
    const initialTitle = document.title;
    let sent = false;

    const send = () => {
      if (sent) return;
      sent = true;
      observer.disconnect();
      window.clearTimeout(timer);
      window.removeEventListener("pagehide", send);
      trackPageView(pageLocation, document.title);
    };

    const observer = new MutationObserver(() => {
      if (document.title !== initialTitle) send();
    });
    observer.observe(document.head, { subtree: true, childList: true, characterData: true });

    const timer = window.setTimeout(send, 1500);
    window.addEventListener("pagehide", send);

    return send;
  }, [pathname, searchStr]);

  return null;
};

export default AnalyticsTracker;
